import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Layout from '../../../../../helpers/Layout';
import Const from '../Const';
import { setDragPopup } from '../../../../../main-layout/reducer';
import CommonConst from '../../../../../common/Const';
const { listComponent } = CommonConst;

const { FUNDAMENTAL, EVENTS, TECHNICAL } = Const.NOTIFICATION_TYPES;

class NotificationHeader extends PureComponent {
  getClassName = type => {
    const { type: currentType } = this.props;

    return type === currentType ? 'current' : '';
  };

  openSettingPopup = () => {
    const { setDragPopup, toggleShow } = this.props;
    const [alertComponent] = Layout.layout.root.getItemsByFilter(item => {
      return (
        item.config.component === listComponent.Alerts &&
        item.type === 'component'
      );
    });
    toggleShow();
    if (alertComponent) {
      alertComponent.parent.setActiveContentItem(alertComponent);
    } else {
      setDragPopup({
        isShow: true,
        componentName: listComponent.Alerts,
        content: `common.listComponent.${listComponent.Alerts}`,
        icon: 'icon-bell',
      });
    }
  };

  render() {
    const { changeType } = this.props;
    return (
      <li className="li-header">
        <div className="header-drop-notis pl-8 pr-8 d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <div
              className={`notification-type ${this.getClassName(FUNDAMENTAL)}`}
              onClick={() => changeType(FUNDAMENTAL)}
            >
              {I18n.t('alerts.fundamental')}
            </div>
            <div
              onClick={() => changeType(EVENTS)}
              className={`notification-type ${this.getClassName(EVENTS)}`}
            >
              {I18n.t('alerts.events')}
            </div>
            <div
              onClick={() => changeType(TECHNICAL)}
              className={`notification-type ${this.getClassName(TECHNICAL)}`}
            >
              {I18n.t('alerts.technical')}
            </div>
          </div>

          <div onClick={this.openSettingPopup} className="setting-button">
            {I18n.t('alerts.setting')}
          </div>
        </div>
      </li>
    );
  }
}

NotificationHeader.propTypes = {
  changeType: PropTypes.func.isRequired,
  setDragPopup: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setDragPopup,
};

export default connect(
  null,
  mapDispatchToProps,
)(NotificationHeader);
